(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/start', {
      templateUrl: 'modules/app/data/start/start.html',
      controller: 'StartCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('StartCtrl', ['$scope', '$window', 'OrganizationSettings', 'User', 'Analytics', function ($scope, $window, OrganizationSettings, User, Analytics) {
    $scope.essentialsTier = false;
    $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
    $scope.helpClicked = Analytics.helpLinkClicked;
    var session = User.get(),
      orgId = session.organization && session.organization.id;
    OrganizationSettings.getForOrganization(orgId).then(function (settings) {
      $scope.essentialsTier = settings.pricingTier === "ESSENTIALS";
      if ($scope.essentialsTier) {
        $scope.helpLink = "http://watershedlrs.com/essentials/knowledge-base";
      }
    });
    $scope.section = "start";
  }]);
})();
